/**
 * helpers.js - percentage clamping, sign-off roll-ups and the date/relative-time
 * formatting used across the public sign-off sheet. All pure.
 */

export function clampPct(item) {
  if (item && Number.isFinite(item.pct)) return Math.max(0, Math.min(100, Math.round(item.pct)));
  const total = (item && item.total) || 0;
  if (!total) return 0;
  const signed = (item.done || 0) + (item.na || 0);
  return Math.max(0, Math.min(100, Math.round((signed / total) * 100)));
}

export function signedCount(item) {
  return ((item && item.done) || 0) + ((item && item.na) || 0);
}

export function rollUp(disciplines) {
  let signed = 0;
  let total = 0;
  (disciplines || []).forEach((d) => {
    signed += signedCount(d);
    total += (d && d.total) || 0;
  });
  return { signed, total, pct: total ? Math.max(0, Math.min(100, Math.round((signed / total) * 100))) : 0 };
}

export function relTime(ts, now) {
  if (!ts) return '';
  const s = Math.max(0, Math.round((now - ts) / 1000));
  if (s < 10) return 'just now';
  if (s < 60) return s + 's ago';
  const m = Math.round(s / 60);
  if (m < 60) return m + 'm ago';
  const h = Math.round(m / 60);
  if (h < 24) return h + 'h ago';
  return Math.round(h / 24) + 'd ago';
}

// Date-only values ("2026-07-17") parse as UTC midnight and would render a day
// early west of Greenwich, so read those as local calendar dates instead.
export function toLocalDate(d) {
  if (typeof d === 'string') {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d.trim());
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  }
  return new Date(d);
}

export function fmtDate(d) {
  if (!d) return '';
  const t = toLocalDate(d);
  if (Number.isNaN(t.getTime())) return String(d);
  const opts = { month: 'short', day: 'numeric' };
  if (t.getFullYear() !== new Date().getFullYear()) opts.year = 'numeric';
  return t.toLocaleDateString(undefined, opts);
}

export function fmtStamp(d) {
  if (!d) return '';
  const t = new Date(d);
  if (Number.isNaN(t.getTime())) return '';
  return t.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function pad2(n) {
  return n < 10 ? '0' + n : String(n);
}

/* ------------------------------- building blocks ------------------------------ */
